import {
  ButtonPrimary, ButtonTertiary, DialogBox, DialogBoxBody, DialogBoxHeader, IconWarning, dlsColorWarning,
} from '@americanexpress/dls-react';
import React from 'react';
import * as PropTypes from 'prop-types';
import { ErrorBoundary } from '../ErrorHandling';

const ConfirmUserPopup = ({
  displayPopup,
  onConfirm,
  confirmLabel = 'Yes',
  onDeny,
  denyLabel = 'No',
  header = 'Do you want to leave without saving changes?',
  message = '',
  subMessage = '',
  id = 'ConfirmUserPopup',
  headerStyle = {},
  messageStyle = {},
  subMessageStyle = { marginBottom: '50px' },
  dialogTheme = {},
  showWarningIcon = false,
}) => {
  if (!displayPopup) {
    return null;
  }

  return (
    <>
      <ErrorBoundary>
        <DialogBox
          onClose={onDeny}
          id={`${id}-dialog-box`}
          theme={{ zIndex: 99999, '> [role=dialog]': { ...dialogTheme } }}
        >
          {showWarningIcon && (
            <IconWarning size="lg" theme={{ ...dlsColorWarning }} filled={true} />
          )}
          <DialogBoxHeader id={`${id}-dialog-box-header`}>
            <p style={{ ...headerStyle }}>{header}</p>
          </DialogBoxHeader>
          <DialogBoxBody id={`${id}-dialog-box-body`}>
            <p style={{ ...messageStyle, marginBottom: subMessage ? '10px' : '50px' }}>{message}</p>
            {subMessage && <p style={{ ...subMessageStyle }}>{subMessage}</p>}
            <ButtonPrimary
              id={`${id}-dialog-box-confirm`}
              className="margin-auto-lr margin-1-b"
              onClick={onConfirm}
              theme={{
                display: 'block',
                width: '100%',
              }}
            >
              {confirmLabel}
            </ButtonPrimary>

            {onDeny && (
              <ButtonTertiary
                id={`${id}-dialog-box-stay`}
                className="margin-auto-lr"
                theme={{
                  display: 'block',
                  width: '100%',
                }}
                onClick={onDeny}
              >
                {denyLabel}
              </ButtonTertiary>
            )}
          </DialogBoxBody>
        </DialogBox>
      </ErrorBoundary>
    </>
  );
};

ConfirmUserPopup.displayName = 'ConfirmUserPopup';

ConfirmUserPopup.propTypes = {
  // eslint-disable-next-line react/boolean-prop-naming
  displayPopup: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string,
  onDeny: PropTypes.func.isRequired,
  denyLabel: PropTypes.string,
  message: PropTypes.string,
  subMessage: PropTypes.string,
  header: PropTypes.string,
  headerStyle: PropTypes.shape({}),
  messageStyle: PropTypes.shape({}),
  dialogTheme: PropTypes.shape({}),
  showWarningIcon: PropTypes.bool,
  subMessageStyle: PropTypes.shape({}),
  id: PropTypes.string,
};

export default ConfirmUserPopup;
